import { render, staticRenderFns } from "./tag_summary_detail.vue?vue&type=template&id=cc23d94a&scoped=true"
import script from "./tag_summary_detail.vue?vue&type=script&lang=js"
export * from "./tag_summary_detail.vue?vue&type=script&lang=js"
import style0 from "./tag_summary_detail.vue?vue&type=style&index=0&id=cc23d94a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc23d94a",
  null
  
)

export default component.exports